var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnifyLogoBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 36,
    viewBox: "0 0 131 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.366C0 27.7551 0.0631952 28.1436 0.218293 28.5005C1.33424 31.0681 3.45151 32.9433 6.02474 34.136C10.7131 32.5601 12.4105 28.7157 12.6043 26.9749V18.3131C12.6043 15.1383 12.024 11.7401 9.44678 9.88616C6.35986 7.66558 2.33635 6.98853 0 6.98853V27.366Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5042 0C19.7304 0.316511 14.2583 3.5903 13.34 8.24978C13.3119 8.39238 13.301 8.53808 13.301 8.68342V15.2568V27.2653C13.1054 29.0216 11.5601 32.9325 6.94385 34.526C14.0851 37.2877 24.0278 35.1835 26.3635 28.4008C26.4643 28.108 26.5042 27.7972 26.5042 27.4876V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7638 29.5662C43.6389 29.5662 41.2072 28.8144 39.4686 27.3107C37.7534 25.807 36.8959 23.6338 36.8959 20.7909V6.51782H40.7373V20.6499C40.7373 22.553 41.2542 23.9745 42.288 24.9142C43.3452 25.854 44.8372 26.3239 46.7638 26.3239C48.6668 26.3239 50.1353 25.854 51.1691 24.9142C52.2263 23.9745 52.755 22.553 52.755 20.6499V6.51782H56.5611V20.7909C56.5611 23.6338 55.7036 25.807 53.9884 27.3107C52.2733 28.8144 49.8651 29.5662 46.7638 29.5662Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1718 29.2138V6.51782H64.5551L76.3966 23.2226V6.51782H80.2027V29.2138H76.8195L65.0133 12.5442V29.2138H61.1718Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0307 29.2138V6.51782H88.8721V29.2138H85.0307Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6775 29.2138V6.51782H109.114V9.51341H97.5189V16.3856H107.81V19.346H97.5189V29.2138H93.6775Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.053 29.2138V20.7909L110.912 6.51782H114.894L120.956 17.5486L127.018 6.51782H131L122.859 20.7909V29.2138H119.053Z",
    fill: "white"
  })));
}

export default __webpack_public_path__ + "media/f7c6f278.svg";
export { SvgUnifyLogoBg as ReactComponent };